// assets/product-stories.js
(function () {
  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.from(root.querySelectorAll(sel)); }

  function clamp(n, a, b) { return Math.max(a, Math.min(b, n)); }

  function getVideoSrc(videoObj) {
    // Shopify file "video" setting returns an object with sources in most themes.
    // We pass src precomputed from Liquid where possible, but keep this as fallback.
    if (!videoObj) return null;
    if (typeof videoObj === 'string') return videoObj;
    if (videoObj.sources && videoObj.sources.length) return videoObj.sources[0].url;
    return null;
  }

  function init(el) {
    const dataEl = qs(el, 'script[data-stories-json]');
    if (!dataEl) return;

    let data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data || !data.tiles || !data.tiles.length) return;

    const modal = document.createElement('div');
    modal.className = 'product-stories-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = `
      <div class="product-stories-modal__backdrop" data-backdrop></div>
      <div class="product-stories-modal__panel" role="dialog" aria-modal="true" aria-label="Product stories">
        <div class="product-stories-modal__frame">
          <div class="product-stories-modal__top">
            <div class="product-stories-modal__bars" data-bars></div>
            <div class="product-stories-modal__header">
              <div class="product-stories-modal__title" data-title></div>
              <button class="product-stories-modal__close" type="button" aria-label="Close" data-close>
              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 50 50">
<path d="M 9.15625 6.3125 L 6.3125 9.15625 L 22.15625 25 L 6.21875 40.96875 L 9.03125 43.78125 L 25 27.84375 L 40.9375 43.78125 L 43.78125 40.9375 L 27.84375 25 L 43.6875 9.15625 L 40.84375 6.3125 L 25 22.15625 Z" fill="white"></path>
</svg>
              </button>
            </div>
          </div>

          <div class="product-stories-modal__stage">
            <img class="product-stories-modal__media" data-img hidden />
            <video class="product-stories-modal__media" data-video hidden playsinline muted></video>
          </div>

          <div class="product-stories-modal__caption" data-caption hidden></div>

          <div class="product-stories-modal__nav">

  <!-- Story navigation -->
  <button type="button" class="ps-nav ps-nav--story ps-nav--prev" aria-label="Previous story" data-prev-story>
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="next-button">
  <path fill="#FFF" fill-rule="evenodd" d="M8.75 9.791V7.498a2.247 2.247 0 0 0-2.247-2.248H6.5a2.25 2.25 0 0 0-2.25 2.25v8.97a2.248 2.248 0 0 0 2.248 2.248H6.5a2.25 2.25 0 0 0 2.25-2.25v-2.259c.071.054.145.104.223.149l6.612 3.968a2.75 2.75 0 0 0 4.165-2.358V8.032a2.75 2.75 0 0 0-4.165-2.358L8.972 9.642a2.604 2.604 0 0 0-.222.149Zm-1.5-2.293c0-.413-.334-.748-.747-.748H6.5a.75.75 0 0 0-.75.75v8.97c0 .413.334.748.748.748H6.5a.75.75 0 0 0 .75-.75v-8.97Zm9.107-.537A1.249 1.249 0 0 1 18.25 8.032v7.936a1.249 1.249 0 0 1-1.893 1.071l-6.612-3.967a1.252 1.252 0 0 1 0-2.144l6.612-3.967Z" clip-rule="evenodd"></path>
</svg>
  </button>

  <button type="button" class="ps-nav ps-nav--story ps-nav--next" aria-label="Next story" data-next-story>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="next-button">
  <path fill="#FFF" fill-rule="evenodd" d="M15.25 9.791V7.498a2.247 2.247 0 0 1 2.247-2.248h.003a2.25 2.25 0 0 1 2.25 2.25v8.97a2.248 2.248 0 0 1-2.248 2.248H17.5a2.25 2.25 0 0 1-2.25-2.25v-2.259a2.604 2.604 0 0 1-.223.149l-6.612 3.968a2.75 2.75 0 0 1-4.165-2.358V8.032a2.75 2.75 0 0 1 4.165-2.358l6.613 3.968c.076.046.15.096.221.149Zm1.5-2.293c0-.413.334-.748.747-.748h.003a.75.75 0 0 1 .75.75v8.97a.748.748 0 0 1-.748.748H17.5a.75.75 0 0 1-.75-.75v-8.97Zm-9.107-.537A1.249 1.249 0 0 0 5.75 8.032v7.936a1.249 1.249 0 0 0 1.893 1.071l6.612-3.967a1.252 1.252 0 0 0 0-2.144L7.643 6.961Z" clip-rule="evenodd"></path>
</svg>
  </button>

  <!-- Slide navigation -->
  <button type="button" class="ps-nav ps-nav--slide ps-nav--prev" aria-label="Previous slide" data-prev-slide>
  <svg width="28" height="28" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M15 5 L8 12 L15 19" 
        stroke="#000000" 
        stroke-width="2.5" 
        stroke-linecap="round" 
        stroke-linejoin="round" 
        fill="none"/>
</svg>
  </button>

  <button type="button" class="ps-nav ps-nav--slide ps-nav--next" aria-label="Next slide" data-next-slide>
<svg width="28" height="28" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M9 5 L16 12 L9 19" 
        stroke="#000000" 
        stroke-width="2.5" 
        stroke-linecap="round" 
        stroke-linejoin="round" 
        fill="none"/>
</svg>
  </button>
</div>
        </div>
      </div>
    `;
    document.body.appendChild(modal);

    const barsWrap = qs(modal, '[data-bars]');
    const titleEl = qs(modal, '[data-title]');
    const captionEl = qs(modal, '[data-caption]');
    const imgEl = qs(modal, '[data-img]');
    const videoEl = qs(modal, '[data-video]');

    

    let tileIndex = 0;
    let slideIndex = 0;

    let timer = null;
    let paused = false;
    let slideStart = 0;
    let slideDuration = 0;

    function clearTimer() {
      if (timer) cancelAnimationFrame(timer);
      timer = null;
    }

    function setBarProgress(i, pct) {
      const bar = barsWrap.children[i];
      if (!bar) return;
      const fill = bar.querySelector('i');
      if (fill) fill.style.width = `${pct}%`;
    }

    function markBars(count, activeIndex) {
      barsWrap.innerHTML = '';
      for (let i = 0; i < count; i++) {
        const bar = document.createElement('div');
        bar.className = 'product-stories-modal__bar';
        bar.innerHTML = '<i></i>';
        barsWrap.appendChild(bar);
        setBarProgress(i, i < activeIndex ? 100 : 0);
      }
    }

    function stopMedia() {
      imgEl.hidden = true;
      imgEl.removeAttribute('src');

      videoEl.hidden = true;
      videoEl.pause();
      videoEl.removeAttribute('src');
      videoEl.load();
    }

function updateNavState() {
  const tile = data.tiles[tileIndex];

  const prevSlideBtn = qs(modal, '[data-prev-slide]');
  const nextSlideBtn = qs(modal, '[data-next-slide]');
  const prevStoryBtn = qs(modal, '[data-prev-story]');
  const nextStoryBtn = qs(modal, '[data-next-story]');

  const hasMultipleSlides = tile.slides.length > 1;

  // Hide slide navigation when this story only contains one asset.
  prevSlideBtn.hidden = !hasMultipleSlides;
  nextSlideBtn.hidden = !hasMultipleSlides;

  if (hasMultipleSlides) {
    prevSlideBtn.disabled = slideIndex === 0;
    nextSlideBtn.disabled = slideIndex === tile.slides.length - 1;
  }

  // Keep story navigation available.
  prevStoryBtn.disabled = tileIndex === 0;
  nextStoryBtn.disabled = tileIndex === data.tiles.length - 1;
}

function nextStory() {
  if (tileIndex >= data.tiles.length - 1) return;
  tileIndex++;
  slideIndex = 0;
  renderSlide();
}

function prevStory() {
  if (tileIndex <= 0) return;
  tileIndex--;
  slideIndex = 0;
  renderSlide();
}

    function openModal() {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      modal.setAttribute('aria-hidden', 'false');
    }

    function closeModal() {
      clearTimer();
      stopMedia();
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }

function nextSlide() {
  const tile = data.tiles[tileIndex];

  if (slideIndex < tile.slides.length - 1) {
    slideIndex++;
  } else {
    // If last slide → go to next story if exists
    if (tileIndex < data.tiles.length - 1) {
      tileIndex++;
      slideIndex = 0;
    } else {
      closeModal(); // no more stories
      return;
    }
  }

  renderSlide();
}

function prevSlide() {
  if (slideIndex > 0) {
    slideIndex--;
  } else {
    if (tileIndex > 0) {
      tileIndex--;
      const prevTile = data.tiles[tileIndex];
      slideIndex = prevTile.slides.length - 1;
    } else {
      return;
    }
  }

  renderSlide();
}

    function startProgress(durationMs) {
      clearTimer();
      paused = false;
      slideStart = performance.now();
      slideDuration = durationMs;

      const localTile = data.tiles[tileIndex];

      function tick(now) {
        if (paused) {
          timer = requestAnimationFrame(tick);
          return;
        }
        const elapsed = now - slideStart;
        const pct = clamp((elapsed / slideDuration) * 100, 0, 100);
        setBarProgress(slideIndex, pct);

        if (elapsed >= slideDuration - 8) {
          // Fill and advance
          setBarProgress(slideIndex, 100);
          // mark previous bars complete
          for (let i = 0; i < slideIndex; i++) setBarProgress(i, 100);
          nextSlide();
          return;
        }

        timer = requestAnimationFrame(tick);
      }

      // ensure bars for current tile are correct
      markBars(localTile.slides.length, slideIndex);
      timer = requestAnimationFrame(tick);
    }

    function renderSlide() {
      clearTimer();
      stopMedia();

      const tile = data.tiles[tileIndex];
      const slide = tile.slides[slideIndex];

      titleEl.textContent = tile.title || '';

      if (slide.caption && slide.caption.trim().length) {
        captionEl.hidden = false;
        captionEl.textContent = slide.caption;
      } else {
        captionEl.hidden = true;
        captionEl.textContent = '';
      }

      // reset bars for tile and mark completed
      markBars(tile.slides.length, slideIndex);
      for (let i = 0; i < slideIndex; i++) setBarProgress(i, 100);

      if (slide.type === 'video' && slide.src) {
        videoEl.hidden = false;
        videoEl.src = slide.src;
        videoEl.currentTime = 0;

        const play = () => {
          // ensure autoplay works
          const p = videoEl.play();
          if (p && typeof p.catch === 'function') p.catch(() => {});
        };

        // Use real duration when available
        videoEl.onloadedmetadata = () => {
          const ms = Math.max(1000, Math.floor((videoEl.duration || 3.5) * 1000));
          startProgress(ms);
          play();
        };

        // In case metadata delays, start a safe fallback timer
        startProgress(slide.duration_ms || 4500);
        play();
      } else {
        imgEl.hidden = false;
        imgEl.src = slide.src;
        startProgress(slide.duration_ms || 3500);
      }
      updateNavState();
    }

    function openAt(tIndex) {
      tileIndex = clamp(tIndex, 0, data.tiles.length - 1);
      slideIndex = 0;
      openModal();
      renderSlide();
    }

    // Pause on press/hold like IG
    let holding = false;
    function pause() {
      paused = true;
      if (!videoEl.hidden) videoEl.pause();
    }
    function resume() {
      paused = false;
      // adjust start time so progress continues from current %:
      // we approximate by reading current fill width
      const fill = barsWrap.children[slideIndex]?.querySelector('i');
      const pct = fill ? parseFloat((fill.style.width || '0').replace('%','')) : 0;
      const elapsed = (pct / 100) * slideDuration;
      slideStart = performance.now() - elapsed;

      if (!videoEl.hidden) {
        const p = videoEl.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      }
    }

    // Wire modal controls
    qs(modal, '[data-close]').addEventListener('click', closeModal);
    qs(modal, '[data-backdrop]').addEventListener('click', closeModal);
    qs(modal, '[data-next-slide]').addEventListener('click', nextSlide);
qs(modal, '[data-prev-slide]').addEventListener('click', prevSlide);
qs(modal, '[data-next-story]').addEventListener('click', nextStory);
qs(modal, '[data-prev-story]').addEventListener('click', prevStory);

    // Hold to pause (mouse + touch)
    const nav = qs(modal, '.product-stories-modal__nav');
    nav.addEventListener('mousedown', () => { holding = true; pause(); });
    window.addEventListener('mouseup', () => { if (holding) { holding = false; resume(); } });
    nav.addEventListener('touchstart', () => { holding = true; pause(); }, { passive: true });
    nav.addEventListener('touchend', () => { if (holding) { holding = false; resume(); } }, { passive: true });

    // Escape to close
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeModal();
    });

    // Tile click handlers
    qsa(el, '[data-story-tile]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.getAttribute('data-story-tile'), 10);
        openAt(isNaN(idx) ? 0 : idx);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-stories]').forEach(init);
  });
})();